import React, { FC, useMemo, useState } from 'react';
import { Typography } from 'antd';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CompanyTypeTitle from '~/layouts/CompanyTypeTitle';
import paths from '~/pages/paths';
import { Button, UnorderedList } from '~/components';
import ExpiredDocumentsModal from '~/components/ExpiredDocumentsModal';
import colors from '~/constants/colors';
import { useRefScrollTo } from '~/hooks/useRefScrollTo';
import { useGetApplication } from '~/controllers/wizard';
import { getExpiredDocuments } from '~/utils/getExpiredDocuments';

const LetsStart: FC = () => {
  const history = useHistory();
  const scrollToTopRef = useRefScrollTo();
  const { t } = useTranslation();
  const applicationQuery = useGetApplication();

  const expiredDocuments = useMemo(
    () => getExpiredDocuments(applicationQuery.data?.payload),
    [applicationQuery.data],
  );
  const [isExpiredModalVisible, setIsExpiredModalVisible] = useState(true);

  const onClick = () => {
    history.push(paths.home._);
  };

  return (
    <Container className="CompanyInformationSuccess" ref={scrollToTopRef}>
      <ExpiredDocumentsModal
        visible={isExpiredModalVisible && !!expiredDocuments.length}
        expiredDocuments={expiredDocuments}
        onOk={() => setIsExpiredModalVisible(false)}
      />
      <CompanyTypeTitle text={t('Get started')} subtext={t('On-board Your Business')} />
      <Typography.Paragraph className="CompanyInformationSuccess-Paragraph">
        <p>{t('To complete the journey you will need your:')}</p>
        <p>{t('- Valid Passport, VISA & Emirates ID for Controlling owners and Authorised signatory')}</p>

        <p>{t('- Constitutional documents eg. MOA /AOA/ Board Resolution.')}</p>

        <p>{t('- Share certificate required where Trade License does not mention the ultimate beneficial owners.')}</p>

        <p>{t('- IBAN proof')}</p>
      </Typography.Paragraph>
      <Button
        id="letsStartButton"
        className="CompanyInformationSuccess-Button"
        size="large"
        type="primary"
        onClick={onClick}
      >
        {t('Let’s start!')}
      </Button>
    </Container>
  );
};

const Container = styled.div`
  .CompanyInformationSuccess-Paragraph {
    margin-bottom: 40px;
  }
  .CompanyInformationSuccess-Button {
    margin-bottom: 35px;
  }
  .UnorderedList {
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    color: ${colors.disabledBlueTextColor};
  }
`;

export default LetsStart;
